import { render } from "./PedidosPorColecciones.vue?vue&type=template&id=84511e56&scoped=true"
import script from "./PedidosPorColecciones.vue?vue&type=script&lang=ts"
export * from "./PedidosPorColecciones.vue?vue&type=script&lang=ts"

import "./PedidosPorColecciones.vue?vue&type=style&index=0&id=84511e56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-84511e56"

export default script